import { Button, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";

import API_Calls_Preview from "@/api/calls/API_Calls_Preview";
import ConfirmationModal from "@/components/membership/Modals/ConfirmationModal";
import { percentageChangeBreaksThreshold } from "@/components/membership/Preview/previewUtils";
import SummaryBody from "@/components/membership/Preview/SummaryBody";
import Notifications from "@/components/Notifications/Notifications";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import { parseAdaPath } from "@/utils/util";

import "@/components/membership/Preview/Preview.css";

function Preview() {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({});
  const [isConfirmable, setIsConfirmable] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const { templateData, affiliateFileData, summaryData } =
    useUpdateDataContext();
  const { confirmPreviewSummary } = API_Calls_Preview();
  const summary = summaryData.summary;

  useEffect(() => {
    setIsConfirmable(summary.allow_confirm);
  }, [summary]);

  const handleConfirmClick = async () => {
    if (
      percentageChangeBreaksThreshold(summary.record_count_changes) &&
      templateData.use === "general"
    ) {
      setOpenConfirmationModal(true);
    } else {
      confirmFile();
    }
  };

  const confirmFile = async () => {
    const ada_file = `${summaryData.processTimestamp}/${affiliateFileData.name}@${affiliateFileData.created}/${templateData.name}@${templateData.created}`;
    const res = await confirmPreviewSummary(
      summaryData.processedFileAffiliate,
      ada_file
    );
    if (res.error) {
      setNotification({
        message: "Unable to confirm at this time",
        severity: "error",
        duration: null, // notification will stay open until the user closes it
      });
      console.error("File failed to confirm: ", res);
    } else {
      navigate("/membership/update-data/processing-confirmed");
    }
  };

  const handleCloseModal = () => {
    setOpenConfirmationModal(false);
  };

  return (
    <>
      <Box className="preview-summary-container">
        {Object.keys(summaryData.summary).length > 0 ? (
          <>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                disabled={!isConfirmable}
                className="siteBlue"
                onClick={handleConfirmClick}
              >
                Confirm Results
              </Button>
            </Box>
            <Box sx={{ position: "relative" }}>
              <SummaryBody
                fileData={parseAdaPath(summaryData.fullPath)}
                summaryData={summaryData}
              />
            </Box>
          </>
        ) : null}
      </Box>
      <ConfirmationModal
        open={openConfirmationModal}
        handleClose={handleCloseModal}
        confirmFile={confirmFile}
      />
      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}

export default Preview;
